import { api, type HeadstoneDTO } from '../api/client';
import { getCurrentUser, onUserChange } from '../auth/session';

export type PostQuotaItem = {
  headstoneId: string;
  petId: string;
  petName: string;
  canPostThisWeek: boolean;
  nextAvailableAt?: string | null;
};

export type PostItem = {
  id: string;
  content: string;
  authorId: string;
  headstoneId: string;
  createdAt: string;
  updatedAt: string;
  author: { id: string; emailMasked: string };
  headstone: { id: string; pet: HeadstoneDTO['pet'] };
  commentCount: number;
};

export type CommentItem = {
  id: string;
  content: string;
  authorId: string;
  postId: string;
  petId: string;
  createdAt: string;
  updatedAt: string;
  author: { id: string; emailMasked: string };
  pet: HeadstoneDTO['pet'];
};

let hasHeadstones = false;
let myHeadstones: HeadstoneDTO[] = [];
let quota: PostQuotaItem[] = [];
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((cb) => cb());
}

export function onPostsAccessChange(cb: () => void): () => void {
  listeners.add(cb);
  cb();
  return () => listeners.delete(cb);
}

export function getHasHeadstones(): boolean {
  return hasHeadstones;
}

export function getMyHeadstones(): HeadstoneDTO[] {
  return myHeadstones;
}

export function getPostQuota(): PostQuotaItem[] {
  return quota;
}

export async function refreshPostsAccess(): Promise<boolean> {
  const user = getCurrentUser();
  if (!user) {
    hasHeadstones = false;
    myHeadstones = [];
    quota = [];
    notify();
    return false;
  }

  const { data, error } = await api.GET('/headstones/me', {});
  if (error || !data?.length) {
    hasHeadstones = false;
    myHeadstones = [];
    quota = [];
    notify();
    return false;
  }

  myHeadstones = data as HeadstoneDTO[];
  hasHeadstones = true;

  const quotaRes = await api.GET('/posts/quota', {});
  quota = (quotaRes.data ?? []) as PostQuotaItem[];
  notify();
  return true;
}

export function initPostsAccess(): void {
  onUserChange(() => {
    refreshPostsAccess().catch((err) => console.warn('Posts access refresh failed:', err));
  });
  refreshPostsAccess().catch((err) => console.warn('Posts access refresh failed:', err));
}
